/**
 * Removes a cookie by setting its expiration date to a past date.
 *
 * @param {string} cookieName - The name of the cookie to be removed.
 * @param {string} [path] - The path of the cookie (optional, defaults to '/').
 * @param {string} [domain] - The domain of the cookie (optional).
 */
function removeCookie(cookieName, path = '/', domain) {
  // Set the expiration date to a past date
  const expirationDate = 'Thu, 01 Jan 1970 00:00:00 GMT'

  // Directly set the cookie with the past expiration date
  document.cookie = `${encodeURIComponent(
    cookieName
  )}=; expires=${expirationDate}; path=${path}`

  // If domain is provided, include it in the cookie string
  if (domain) {
    document.cookie = `${encodeURIComponent(
      cookieName
    )}=; expires=${expirationDate}; path=${path}; domain=${domain}`
  }
}

export { removeCookie }
